import { useContext, useState, useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';

import { AppContext } from 'commons-ui';
import useService from '../../utils/useService';

const useFindUserBucket = () => {
	const [userId, setUserId] = useState('');
	const [loading, setLoading] = useState(false);
	const [result, setResult] = useState<{ bucketName: string } | null>(null);
	const { showAlert } = useContext(AppContext);
	const history = useHistory();
	const location = useLocation();
	const { requestFindUserBucket } = useService();
	const data = _get(location, ['state', 'rowData']);

	const handleLookup = useCallback(() => {
		if (!userId.trim()) {
			showAlert('Please enter a User ID', { type: 'error' });
			return;
		}
		setLoading(true);
		setResult(null);
		requestFindUserBucket({ userId: userId.trim(), experimentName: data.name }).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.error || res?.data?.externalMessage || 'Error occurred while fetching user bucket', {
						type: 'error'
					});
					setLoading(false);
					return;
				}
				setResult({
					bucketName: res.data.bucket
				});
				setLoading(false);
			},
			(err: any) => {
				showAlert(`Error: ${err?.response?.data?.externalMessage || err?.response?.data?.error || 'Unknown error'}`, {
					type: 'error'
				});
				setLoading(false);
			}
		);
	}, [userId, data, requestFindUserBucket, showAlert]);

	const handleBack = useCallback(() => {
		history.goBack();
	}, [history]);

	return {
		experimentName: data?.name,
		userId,
		setUserId,
		loading,
		result,
		handleLookup,
		handleBack
	};
};

export default useFindUserBucket;
